import React, { useEffect, useState } from 'react';
import { DEP_SV_05 } from '@upgrade/ui-utils/constants/program-definition-code';
import Hero from './hero';
import InfoTypes from '../common/InfoTypes';
import LowerCostSection from '../upgrade-card/lower-cost-section';
import Apps from '../home/apps';
import FAQ from '../common/FAQ';
import RecommendedArticles from '../common/RecommendedArticles';
import SavingsCalculator from './calculator';
import { getDepositUrl } from '../../utils/get-funnel-url';
import useEmailExperiment from './hooks/useEmailExperiment';
import JointAccounts, { JOIN_ACCOUNT_PREMIER_SAVINGS_TEXT } from '../common/JointAccounts';

const PremierSavings = ({
  hero,
  banner,
  infoTypes,
  lowerCostSection,
  savingsCalculator,
  downloadApps,
  location,
  faq,
  relatedArticles
}) => {
  const { isReady, captureEmailExperiment } = useEmailExperiment(location);
  const [depositUrl, setDepositUrl] = useState(`/deposit/?pdc=${DEP_SV_05}`);

  useEffect(() => {
    setDepositUrl(getDepositUrl({ location }));
  }, [location]);

  return (
    <>
      {hero && <Hero {...{ hero, banner, depositUrl, location, isReady, captureEmailExperiment }} />}
      {infoTypes && <InfoTypes {...{ infoTypes }} borderless />}
      {lowerCostSection && <LowerCostSection {...{ lowerCostSection }} borderless />}
      {savingsCalculator && (
        <div id="savings-calculator">
          <SavingsCalculator {...{ ...savingsCalculator, depositUrl }} />
        </div>
      )}
      {downloadApps && <Apps downloadApps={{ ...downloadApps, innerPadding: '3xl' }} borderless />}
      <JointAccounts text={JOIN_ACCOUNT_PREMIER_SAVINGS_TEXT} />
      {relatedArticles?.length ? <RecommendedArticles {...{ relatedArticles }} borderless /> : null}
      {faq && <FAQ {...{ faq }} />}
    </>
  );
};

export default PremierSavings;
